import { render, staticRenderFns } from "./Infringements.vue?vue&type=template&id=018916d4"
import script from "./Infringements.vue?vue&type=script&lang=js"
export * from "./Infringements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports